import React from 'react';
import { CheckCircle2, MapPin, Users, Wrench } from 'lucide-react';
export function AcquisitionCriteriaSection() {
  const criteria = [{
    icon: MapPin,
    title: 'Strategic Locations',
    description: 'We target high-traffic neighborhoods in growing Florida markets with strong demographics and limited competition.'
  }, {
    icon: Users,
    title: 'Established Customer Base',
    description: 'We look for laundromats with proven demand, loyal customers, and a history of consistent revenue.'
  }, {
    icon: Wrench,
    title: 'Upgrade Potential',
    description: 'We identify locations where operational improvements and equipment upgrades can drive significant value.'
  }];
  return <section className="py-16 sm:py-20 lg:py-24 bg-[#0b1a1a]" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-12 sm:mb-16" data-id="element-24">
          <h2 className="text-xs sm:text-sm font-semibold text-[#4fd1c5] tracking-widest uppercase mb-3 sm:mb-4" data-id="element-25">
            Acquisition Focus
          </h2>
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 px-4" data-id="element-26">
            What We Look For
          </h3>
          <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed px-4" data-id="element-27">
            We're selective in our acquisitions, focusing on locations with
            strong fundamentals and clear opportunities for operational
            enhancement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16" data-id="element-28">
          {criteria.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="bg-[#0f2424] border border-gray-800 rounded-xl p-6 sm:p-8 hover:border-[#4fd1c5]/30 transition-all duration-300" data-id="element-29">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-lg bg-[#4fd1c5]/10 flex items-center justify-center mb-5 sm:mb-6" data-id="element-30">
                  <Icon className="h-6 w-6 sm:h-7 sm:w-7 text-[#4fd1c5]" data-id="element-31" />
                </div>
                <h4 className="text-lg sm:text-xl font-bold text-white mb-3" data-id="element-32">
                  {item.title}
                </h4>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed" data-id="element-33">
                  {item.description}
                </p>
              </div>;
        })}
        </div>

        {/* Deal Structure */}
        <div className="bg-gradient-to-br from-[#0f2424] to-[#1a3a3a] border border-[#4fd1c5]/20 rounded-2xl p-6 sm:p-8 md:p-12" data-id="element-34">
          <div className="max-w-4xl mx-auto" data-id="element-35">
            <h4 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6 text-center lg:text-left" data-id="element-36">
              Fair, Transparent Deals
            </h4>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-6 text-center lg:text-left" data-id="element-37">
              We believe in creating win-win partnerships with sellers. Our
              process is straightforward, our valuations are fair, and our
              timelines are flexible to meet your needs.
            </p>
            <ul className="space-y-3 sm:space-y-4" data-id="element-38">
              <li className="flex items-start gap-3" data-id="element-39">
                <CheckCircle2 className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5] flex-shrink-0 mt-0.5" data-id="element-40" />
                <span className="text-sm sm:text-base text-gray-300" data-id="element-41">
                  Market-based valuations with transparent methodology
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-42">
                <CheckCircle2 className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5] flex-shrink-0 mt-0.5" data-id="element-43" />
                <span className="text-sm sm:text-base text-gray-300" data-id="element-44">
                  Flexible closing timelines to suit your situation
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-45">
                <CheckCircle2 className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5] flex-shrink-0 mt-0.5" data-id="element-46" />
                <span className="text-sm sm:text-base text-gray-300" data-id="element-47">
                  Confidential process that respects your business
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-48">
                <CheckCircle2 className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5] flex-shrink-0 mt-0.5" data-id="element-49" />
                <span className="text-sm sm:text-base text-gray-300" data-id="element-50">
                  Smooth transition support for staff and customers
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}